// fishAnimation.js

// Utility for random integers
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Fish variants by size
export const fishVariants = {
  small:  ['><>', ' ><((º>'],
  medium: ['   ><(((º>', ' ><(((º>', '><(((º>'],
  large:  ['     ><((((º>', '    ><((((º>', '   ><((((º>'],
  xl:     ['       ><(((((*>', '      ><(((((*>', '     ><(((((*>']
};

// Build swim animation frames
export function createSwimFrames(fishArt) {
  const frames = [];
  const totalSteps = 20;
  for (let i = 0; i <= totalSteps; i++) {
    const verticalOffset = getRandomInt(-1, 1); // up/down wiggle
    const spaces = " ".repeat(i * 2);
    const upDown = verticalOffset === -1 ? "\n" :
                   verticalOffset === 1 ? "\n\n" : "";
    frames.push(upDown + spaces + fishArt);
  }
  frames.push(" ".repeat(totalSteps * 2) + fishArt + "  ✨ Nice catch! 💦");
  return frames;
}
